// extracted by mini-css-extract-plugin
module.exports = {"deletedItem":"Schedule_deletedItem__1YHNy"};